import { render, staticRenderFns } from "./FixedRentalCreate.vue?vue&type=template&id=b0a88622"
import script from "@/scripts/modal/fixedRental/fixedRentalCreate.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/fixedRental/fixedRentalCreate.js?vue&type=script&lang=js&external"
import style0 from "./FixedRentalCreate.vue?vue&type=style&index=0&id=b0a88622&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports